import { Autocomplete, TextField } from "@mui/material"
import { KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import { type FC, useMemo } from "react"

import { useLookupWarehouses } from "@/hooks/useLookupWarehouses"
import type { Option } from "@/types/form-fields"

interface TabletWarehouseFilterProps {
  selectedValue: string | null
  onChange: (warehouseId: string | null) => void
}

export const TabletWarehouseFilter: FC<TabletWarehouseFilterProps> = ({ selectedValue, onChange }) => {
  const { warehouses, isFetching } = useLookupWarehouses({ limit: 1000 })

  const warehouseOptions: Option<string>[] = useMemo(
    () => warehouses.map((w) => ({ value: w.id, label: w.label })),
    [warehouses]
  )

  const selectedOption = warehouseOptions.find((option) => option.value === selectedValue)

  return (
    <Autocomplete
      value={selectedOption}
      options={warehouseOptions}
      loading={isFetching}
      popupIcon={<KeyboardArrowDownOutlined />}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(_, newValue) => {
        onChange(newValue?.value || null)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder='All Warehouses'
          variant='outlined'
          size='medium'
          className='min-w-[300px]'
        />
      )}
      className='min-w-[300px]'
      size='medium'
    />
  )
}
